import { screen } from 'styles/mq'
import { imageSize } from 'components/hooks/utils'
import { DetailContainer } from './styled'
import { useVideoInViewport } from './videoPlay'

export const Detail: React.FC<{
  dir: 'left' | 'right'
  media: string
  text: string | JSX.Element
}> = ({ dir, media, text }) => {
  const videoRef = useVideoInViewport()
  /*const video1Ref = useVideoInViewport()
  const video2Ref = useVideoInViewport()*/

  return media.endsWith('.mp4') ? (
    <DetailContainer $dir={dir}>
      <video loop muted autoPlay playsInline ref={videoRef}>
        <source src={media} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div>
        <p>{text}</p>
      </div>
    </DetailContainer>
  ) : (
    <DetailContainer $dir={dir}>
      <picture>
        <source
          media={'(min-width:' + screen.m + ')'}
          srcSet={imageSize(media, 'm')}
        />
        <source
          media={'(min-width:' + screen.xl + ')'}
          srcSet={imageSize(media, 'l')}
        />
        <img alt="" src={imageSize(media, 's')} />
      </picture>
      <div>
        <p>{text}</p>
      </div>
    </DetailContainer>
  )
}
